import { createSlice } from "@reduxjs/toolkit";

const initialGameDetailsState = { data: {}, isOpen: false }

const gameDetailsSlice = createSlice({
    name: 'gameDetailsSlice',
    initialState: initialGameDetailsState,
    reducers: {
        openModal(state, action) {
            state.data = action.payload
            state.isOpen = true
        },
        closeModal(state, action) {
            state.data = {}
            state.isOpen = false
        }
    }
})

export const gameDetailsActions = gameDetailsSlice.actions;
export default gameDetailsSlice